import React from 'react';
import { useQuery } from '@apollo/client';
import { mergeStyles } from '@fluentui/react';
import { StackShim as Stack, StackItemShim as StackItem } from '@fluentui/react-migration-v8-v9';
import { Button, FluentProvider, webLightTheme } from '@fluentui/react-components';
import GET_ENTITY_STATUSES_QUERY from '../../utils/statApi/EntityStatusApi';
import IDropdownReference from '../../utils/types/IDropdownReference';
import { multiDropdownMediumWrapper } from '../companies/documents/CompanyDocumentStyles';
import { IInvalidServiceContactsSearchState } from './InvalidServiceContactsList';
import { filterWrapperStyles } from '../../app/common/styles/CommonStyleObjects';
import MultiSelectDropdown from '../common/MultiSelectDropdown';
import IDropdownOption from '../../utils/types/IDropdownOption';

interface IInvalidServiceContactsFilterProps {
  onResetFiltersClick: () => void;
  filterState: IInvalidServiceContactsSearchState;
  onUpdateState: (propertyName: keyof IInvalidServiceContactsSearchState, value: string[]) => void;
}
const InvalidServiceContactsFilter = (props: IInvalidServiceContactsFilterProps): JSX.Element => {
  const { onResetFiltersClick, filterState, onUpdateState } = props;
  const { entityStatuses } = filterState;
  const { loading, data } = useQuery(GET_ENTITY_STATUSES_QUERY);

  const { entityStatuses: entityStatusesSource } = !loading && data ? data : { entityStatuses: [] };
  const entityStatusOptions =
    entityStatusesSource?.map((entityStatus: IDropdownReference) => {
      return { key: entityStatus.fieldName, text: entityStatus.fieldName };
    }) || [];

  const onUpdateEntityStatus = (
    _event: React.FormEvent<HTMLElement>,
    items: IDropdownOption[],
  ): void => {
    const itemKeys = items.map((item) => item.key.toString());
    onUpdateState('entityStatuses' as keyof IInvalidServiceContactsSearchState, itemKeys);
  };

  return (
    <StackItem grow disableShrink className={mergeStyles(filterWrapperStyles.root)}>
      <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
        <h2>Filter</h2>
        <FluentProvider theme={webLightTheme}>
          <Button onClick={onResetFiltersClick}>Reset Filters</Button>
        </FluentProvider>
      </Stack>

      <MultiSelectDropdown
        label="Legal Status"
        className={multiDropdownMediumWrapper}
        onChange={onUpdateEntityStatus}
        selectedKeys={entityStatuses}
        placeholder="Select an option"
        options={entityStatusOptions}
      />
    </StackItem>
  );
};
export default InvalidServiceContactsFilter;
